
export function ClusterManagerFilter() {
  function filterContext(clusters, filterConfig) {
    const state = filterConfig.state;
    const text = filterConfig.text.toLocaleLowerCase();

    let filteredClusters = clusters;

    // filter by text
    if (text !== '') {
      filteredClusters = filteredClusters.filter((cluster) => {
        return _.any(_.values(cluster), (v) => `${v}`.toLocaleLowerCase().contains(text));
      });
    }

    // filter by state
    if (state !== '*') {
      filteredClusters = filteredClusters.filter((c) => c.state === state);
    }

    // sort by name
    filteredClusters = filteredClusters.sort((cluster) => {
      return cluster.name.toLowerCase();
    });

    return filteredClusters;
  }
  return filterContext;
}



// WEBPACK FOOTER //
// ./src/app/clusters/cluster-manager.filter.js